import { render } from "./TutosSearch.vue?vue&type=template&id=ecf8cad8"
import script from "./TutosSearch.vue?vue&type=script&lang=js"
export * from "./TutosSearch.vue?vue&type=script&lang=js"

import "./TutosSearch.vue?vue&type=style&index=0&id=ecf8cad8&lang=scss"

import exportComponent from "/var/www/vhosts/universalmusic.fr/sites/crm/www/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__